import { useTheme } from "@emotion/react";
import facepaint from "facepaint";
import { em } from "@util/convertUnits";

const useBreakpoints = (bps, options) => {
  const theme = useTheme();
  const breakpoints = bps || theme.breakpoints;

  return facepaint(
    breakpoints.map((bp) => `@media (min-width: ${em(bp, 16)})`),
    options
  );
};

export default useBreakpoints;
